import styled from 'styled-components';

import { NCWalletTokenList } from '../../ui/nc-wallet-token-list/NCWalletTokenList';
import { NCWalletHeaderContent } from '../nc-wallet-header-content';

export const NCWalletTokensTab = () => {
	return (
		<>
			<S.Wrapper>
				<NCWalletHeaderContent />
			</S.Wrapper>
			<NCWalletTokenList />
		</>
	);
};

namespace S {
	export const Wrapper = styled.div`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		padding: 0 0 ${({ theme }) => theme.spacings.large} 0;
	`;
}
